import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoTransferencias({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'movimentacoestransferencias', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoTransferencia({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `movimentacoestransferencias/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaotransferencia, params } = payload;

    yield call(api.post, 'movimentacoestransferencias', operacaotransferencia);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacaotransferencia');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `movimentacoestransferencias/${id}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaotransferencia, params } = payload;

    yield call(api.put, 'movimentacoestransferencias', operacaotransferencia);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaotransferencia');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'movimentacoestransferencias', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaotransferencia/OPERACAOTRANSFERENCIAS_IN_REQUEST',
    requestOperacaoTransferencias
  ),
  takeLatest(
    '@operacaotransferencia/DELETE_OPERACAOTRANSFERENCIA',
    deleteOperacaoTransferencia
  ),
  takeLatest(
    '@operacaotransferencia/SUCCESS_REMOVE',
    requestOperacaoTransferencias
  ),
  takeLatest('@operacaotransferencia/STORE_OPERACAOTRANSFERENCIA', store),
  takeLatest('@operacaotransferencia/FIND_OPERACAOTRANSFERENCIA', find),
  takeLatest('@operacaotransferencia/UPDATE_OPERACAOTRANSFERENCIA', update),
  takeLatest('@operacaotransferencia/RECORD_FILTERING', applyedFilters),
]);
